import React from 'react'
import { useRTL } from '../../contexts/RTLContext'
import { useFloating } from '../../contexts/FloatingContext'
import { trackWatermarkClicked } from '../../services/analytics.service'

interface PoweredByWatermarkProps {
  projectId: string
  threadId: string
  messages?: any[]
}

export const PoweredByWatermark = ({ projectId, threadId, messages = [] }: PoweredByWatermarkProps) => {
  const { isRTL } = useRTL()
  const { isFloating } = useFloating()
  
  const handleWatermarkClick = () => {
    trackWatermarkClicked(projectId, threadId, messages)
  }
  
  return (
    <div 
      className="w-full flex justify-center items-center px-4 mt-1"
      style={{
        background: isFloating ? 'transparent' : undefined
      }}
    >
      <div 
        className={`w-full max-w-3xl flex ${isRTL ? 'justify-end' : 'justify-start'} px-4`}
        style={{
          background: isFloating ? 'transparent' : undefined
        }}
      >
        <a
          href="https://whtvr.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-gray-400 hover:text-gray-600 transition-colors duration-200 no-underline"
          style={{
            direction: isRTL ? 'rtl' : 'ltr',
            background: isFloating ? 'transparent' : undefined
          }}
          onClick={handleWatermarkClick}
        >
          powered by whtvr.ai
        </a>
      </div>
    </div>
  )
} 